@if (userLinks) {
  @for (filterName of filterConvert ; track filterName; let i = $index) {
    <div>
      @if (mode=='accordion' && userLinks[filterName]) {
        <div class="section sidebar-widget-1"
          [ngClass]="{'invisible' : isHiddenFilter(filterName)}"  [ngStyle]="{'height': isHiddenFilter(filterName)?'0':'auto'}">
          <accordion  class="accordion-{{filterName}}">
            <accordion-group #g_cs [isOpen]="i < openCatalogueFiltersCount && !sharedData.isMobileMode()">
              <div accordion-heading>
                <span class="mx-1">
                  @if (userLinks[filterName].image) {
                    <img [src]="userLinks[filterName].icon" class="mx-1"/>
                  }
                  @if (userLinks[filterName].icon) {
                    <i class="fa" [class]="userLinks[filterName].icon"></i>
                  }
                {{userLinks[filterName].alias || filterName | translate}}</span>
                @if (filterCount(filterName)) {
                  <span class="amount" dir="ltr">({{filterCount(filterName)}})
                  </span>
                }
                <i class="pull-right fa"
                           [ngClass]="{
                    'fa-minus-square-o': g_cs?.isOpen && !sharedData.isMobileMode(),
                    'fa-plus-square-o': !g_cs?.isOpen && !sharedData.isMobileMode(),
                    'fa-angle-up': g_cs?.isOpen && sharedData.isMobileMode(),
                    'fa-angle-down': !g_cs?.isOpen && sharedData.isMobileMode()}">
                </i>
                @if (showClear(filterName)) {
                  <a class="pull-right clear-btn" (click)="clear($event,filterName)" translate>clear</a>
                }
              </div>
              <div id="filter-{{i}}">
                <div class="filters-holder">
                  @if (filtersList[filterName].length > 9) {
                    <input class="search-filters" placeholder="{{'filter by...' | translate}}" attr.aria-label="{{'Search in filter'| translate}}" [(ngModel)]="query[i]">
                  }
                  <div>
                    @switch (userLinks[filterName].displayType) {
                      @case (FieldDisplayType.CHECKBOX) {
                        <div>
                          <ng-container *ngTemplateOutlet="tplfiltersList;  context:{filtersList: filtersList, filterName: filterName, i:i}"></ng-container>
                        </div>
                      }
                      @case (FieldDisplayType.IMAGE) {
                        <div>
                          <ng-container *ngTemplateOutlet="tplImageSelect;  context:{filterName: filterName, i: i}"></ng-container>
                        </div>
                      }
                      @case (FieldDisplayType.RADIO_BUTTON) {
                        <div>
                          <ng-container *ngTemplateOutlet="tplRadioButtonList;  context:{filtersList: filtersList, filterName: filterName, i:i}"></ng-container>
                        </div>
                      }
                      @default {
                        <div>
                          <ng-container *ngTemplateOutlet="tplfiltersList;  context:{filtersList: filtersList, filterName: filterName, i:i}"></ng-container>
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
            </accordion-group>
          </accordion>
        </div>
      }
      @if (mode=='dropdown' && userLinks[filterName]) {
        <div class="dropdown-mode">
          <div ngbDropdown class="dropdown" id="dropdown-fadeIn" display="static">
            <button class="btn app-black-border d-flex justify-content-between align-items-center" type="button" data-toggle="dropdown" ngbDropdownToggle>
              {{userLinks[filterName].alias || filterName | translate}}
              <i class="fa fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu class="dropdown-menu">
              @if (filtersList[filterName].length > 9) {
                <input class="form-control search-item" placeholder="search.." [(ngModel)]="query[i]">
              }
              <div>
                @switch (userLinks[filterName].displayType) {
                  @case (FieldDisplayType.CHECKBOX) {
                    <div>
                      <ng-container *ngTemplateOutlet="tplfiltersList;  context:{filtersList: filtersList, filterName: filterName, i:i}"></ng-container>
                    </div>
                  }
                  @case (FieldDisplayType.IMAGE) {
                    <div>
                      <ng-container *ngTemplateOutlet="tplImageSelect;  context:{filterName: filterName, i: i}"></ng-container>
                    </div>
                  }
                  @case (FieldDisplayType.RADIO_BUTTON) {
                    <div>
                      <ng-container *ngTemplateOutlet="tplRadioButtonList;  context:{filtersList: filtersList, filterName: filterName, i:i}"></ng-container>
                    </div>
                  }
                  @default {
                    <div>
                      <ng-container *ngTemplateOutlet="tplfiltersList;  context:{filtersList: filtersList, filterName: filterName, i:i}"></ng-container>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
}

<ng-template #tplfiltersList let-filtersList="filtersList" let-filterName="filterName" let-i="i">
  <ng-scrollbar class="filters-parent" track="vertical">
    <ul>
      @for (value of filtersList[filterName] | search:'0':query[i]; track trackItem(index, value); let index = $index) {
        @if (value[0]) {
          <li class="d-flex align-items-center" [ngClass]="{'d-none': isHiddenFilter(filterName) && mode=='dropdown', 'dropdown-item': mode=='dropdown'}">
            <mat-pseudo-checkbox (click)="clickedFilter(filterName, value[0], true)" [state]="isChecked(filterName, value[0], true)" title="{{value[0]}}"></mat-pseudo-checkbox>
            <span [innerHtml]="value[0] | safe: 'html'"></span><span class="amount" dir="ltr">{{" ("+value[1]+") "}}</span>
            @if (mode !='dropdown' && isChecked(filterName, value[0]) && dependenceFilters[filterName] && dependenceFilters[filterName][value[0]]) {
              <ul class="p-2 d-inline-block">
                <div *ngTemplateOutlet="tplDependenceFilters;  context:{dependenceFilters: dependenceFilters, filterName: filterName, value: value}"></div>
              </ul>
            }
          </li>
        }
      }
    </ul>
  </ng-scrollbar>
</ng-template>

<ng-template #tplRadioButtonList let-filtersList="filtersList" let-filterName="filterName" let-i="i">
  <ng-scrollbar class="filters-parent" track="vertical">
    <mat-radio-group [name]="filterName">
      @for (value of filtersList[filterName]; track value) {
        <mat-radio-button [value]="value[0]" [checked]="isChecked(filterName, value[0])" title="{{value[0]}}" (change)="clickedFilter(filterName, value[0])">
          {{value[0]}}<span class="amount" dir="ltr">{{" ("+value[1]+") "}}</span>
        </mat-radio-button>
      }
    </mat-radio-group>
  </ng-scrollbar>
</ng-template>

<ng-template #tplDependenceFilters let-dependenceFilters="dependenceFilters" let-filterName="filterName" let-value="value">
  @for (dependFiltersVal of dependenceFilters[filterName][value[0]]; track dependFiltersVal) {
    <div>
      @if (dependFiltersVal['count']) {
        <li>
          <mat-checkbox (click)="clickedFilter(dependFiltersVal['field'], dependFiltersVal['value'])" [checked]="isChecked(dependFiltersVal['field'], dependFiltersVal['value'])" title="{{dependFiltersVal['value']}}">
            {{dependFiltersVal['value']}}<span class="amount" dir="ltr">{{" ("+dependFiltersVal['count']+") "}}</span>
          </mat-checkbox>
        </li>
      }
    </div>
  }
</ng-template>

<ng-template #tplImageSelect let-filterName="filterName" let-i="i">
  <ng-scrollbar class="filters-parent" track="vertical">
    <ul class=" row mx-n2" >
      @for (dependence of dependenceFilters[filterName] | keyvalue | search:'key':query[i]; track dependence; let index = $index) {
        @if (dependence.value) {
          <li class="col-auto p-2 mb-0">
            <mat-checkbox class="selectImage" (click)="clickedFilter(filterName, dependence.key)" [checked]="isChecked(filterName, dependence.key)" title="{{dependence.key}}">
              <img src="{{imagesBaseUrl}}{{userLinks[filterName].unitName}}/{{dependence.value[0].value}}"/>
            </mat-checkbox>
          </li>
        }
      }
    </ul>
  </ng-scrollbar>
</ng-template>
